import React, { useEffect, useState } from "react";
import { Table, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./Adminstrator.css";

const data = [
  {
    date: "01/05/2024",
    orderBy: "Andy",
    department: "Sales",
    receiver: "Jim Miller",
    merchantName: "Jacob Jones",
    item: "Lorem Ipsum",
    dropShipAddress: "989 1st St, New York, NY, 29301",
    action: "Print"
  },
  {
    date: "01/05/2024",
    orderBy: "Sarah",
    department: "Human Resource",
    receiver: "Emma Wilson",
    merchantName: "Albert Flores",
    item: "Lorem Ipsum",
    dropShipAddress: "123 Main St, Miami, FL, 33101",
    action: "Print"
  },
  {
    date: "01/05/2024",
    orderBy: "John",
    department: "IT",
    receiver: "Michael Johnson",
    merchantName: "Ronald Richards",
    item: "Lorem Ipsum",
    dropShipAddress: "45 Lakeview Rd, Chicago, IL, 60601",
    action: "Print"
  },
  {
    date: "01/05/2024",
    orderBy: "Olivia",
    department: "Marketing",
    receiver: "James Brown",
    merchantName: "Savannah Nguyen",
    item: "Lorem Ipsum",
    dropShipAddress: "789 Ocean Dr, San Francisco, CA, 94101",
    action: "Print"
  },
  {
    date: "01/05/2024",
    orderBy: "William",
    department: "Finance",
    receiver: "Sophia Taylor",
    merchantName: "Theresa Webb",
    item: "Lorem Ipsum",
    dropShipAddress: "456 Oak St, Seattle, WA, 98101",
    action: "Shipped"
  },
  {
    date: "01/05/2024",
    orderBy: "David",
    department: "IT",
    receiver: "Mia Thomas",
    merchantName: "Cameron Williamson",
    item: "Lorem Ipsum",
    dropShipAddress: "67 Pine St, Orlando, FL, 32801",
    action: "Print"
  },
  {
    date: "01/05/2024",
    orderBy: "Emma",
    department: "Support",
    receiver: "John Doe",
    merchantName: "Savannah Nguyen",
    item: "Lorem Ipsum",
    dropShipAddress: "789 Ocean Dr, San Francisco, CA, 94101",
    action: "Print"
  },
  {
    date: "01/05/2024",
    orderBy: "Sarah",
    department: "Management",
    receiver: "Sarah Smith",
    merchantName: "Albert Flores",
    item: "Lorem Ipsum",
    dropShipAddress: "888 King St, Austin, TX, 73301",
    action: "Shipped"
  },
  {
    date: "01/05/2024",
    orderBy: "Michael",
    department: "Business Analysis",
    receiver: "David Anderson",
    merchantName: "Jacob Jones",
    item: "Lorem Ipsum",
    dropShipAddress: "102 River Rd, New York, NY, 10001",
    action: "Shipped"
  },
  {
    date: "01/05/2024",
    orderBy: "Olivia",
    department: "Marketing",
    receiver: "Olivia Martinez",
    merchantName: "Ronald Richards",
    item: "Lorem Ipsum",
    dropShipAddress: "300 Maple Ave, Denver, CO, 80201",
    action: "Print"
  },
  {
    date: "01/05/2024",
    orderBy: "John",
    department: "Management",
    receiver: "Mia Thomas",
    merchantName: "Theresa Webb",
    item: "Lorem Ipsum",
    dropShipAddress: "555 Sunset Blvd, Las Vegas, NV, 89101",
    action: "Print"
  },
  {
    date: "01/05/2024",
    orderBy: "Sarah",
    department: "Management",
    receiver: "James Brown",
    merchantName: "Cameron Williamson",
    item: "Lorem Ipsum",
    dropShipAddress: "300 Maple Ave, Denver, CO, 80201",
    action: "Print"
  }
];

const Adminstrator = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [payAccordionOpen, setPayAccordionOpen] = useState(true);

  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(data.length / rowsPerPage);

  const currentData = data.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowsChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  useEffect(() => {
    document.title = `Administrator | bluefaucet`;
    document.getElementById("bodywrap").className = "infr";

    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-12 holisti okhas">
                    <h1 className="d-none d-md-block">Order Processing and Shipment Tracking</h1>
                    <Card>
                      <div className="table-ro mt-2 d-none d-md-block">
                        <Table
                          responsive
                          className="table-no-last-border mb-0"
                        >
                          <thead className="table">
                            <tr className="custom-header">
                              <th className="lft">Date</th>
                              <th>Order By</th>
                              <th>Department</th>
                              <th>Receiver</th>
                              <th>Merchant name</th>
                              <th>Item</th>
                              <th>Drop Ship Address</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentData.map((item, index) => (
                              <tr key={index}>
                                <td className="lef">{item.date}</td>
                                <td>{item.orderBy}</td>
                                <td>{item.department}</td>
                                <td>{item.receiver}</td>
                                <td>{item.merchantName}</td>
                                <td>{item.item}</td>
                                <td>{item.dropShipAddress}</td>
                                <td className="ref"><Link to={process.env.REACT_APP_BASE_URL + "dashboard-merchants-employees"}>{item.action}</Link></td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>

                      <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0 d-md-none">
                        <div className="d-flex align-items-center w-100 justify-content-md-start w-md-auto">
                          <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                            <div className="input-group">
                              <div className="input-group-text border-end-0">
                                <img
                                  src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                                  alt="Search Icon"
                                  className="img-fluid"
                                />
                              </div>
                              <input
                                type="text"
                                className="form-control border-start-0 ps-0"
                                placeholder="Search"
                              />
                            </div>
                          </div>
                          <button type="button" className="sloti">
                            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2" /> Sort
                          </button>
                        </div>
                      </div>
                      <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
                        onClick={() => isMobile && setPayAccordionOpen(!payAccordionOpen)}
                        style={{ cursor: isMobile ? "pointer" : "default" }}
                      >
                        <h5>Order Processing and Shipment Tracking</h5>
                        {isMobile && (
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              (payAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                            }
                            alt="Toggle Arrow"
                          />
                        )}
                      </div>
                      {(!isMobile || payAccordionOpen) && (
                        <>
                          <div className="d-md-none mb-3 ev-mobilex okchavo ocho">
                            {currentData.map((item, index) => (
                              <div
                                key={index}
                                className="col-12 mb-3 main"
                              >

                                <div className="d-flex justify-content-between align-items-center fir mb-3">
                                  <div className="joxily">{item.date}</div>
                                  <div className={`joxiop ${item.action === 'Shipped' ? 'shipped' : 'print'}`}>
                                    {item.action}
                                  </div>
                                </div>

                                <div className="d-flex justify-content-between align-items-center fir mb-2">
                                  <div className="sdtre">{item.item}</div>
                                  <div className="poj">{item.department}</div>
                                </div>

                                <div className="phony mb-2">
                                  <div><img src={process.env.REACT_APP_BASE_URL + 'assests/images/location.png'} alt={item.name} className="me-2" />{item.dropShipAddress}</div>
                                </div>

                                <div className="row two">
                                  <div className="col-4">
                                    <h3>Order By</h3>
                                    <h4>{item.orderBy}</h4>
                                  </div>
                                  <div className="col-4">
                                    <h3>Receiver</h3>
                                    <h4>{item.receiver}</h4>
                                  </div>
                                  <div className="col-4">
                                    <h3>Merchant Name</h3>
                                    <h4>{item.merchantName}</h4>
                                  </div>
                                </div>

                              </div>
                            ))}
                          </div>
                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2 mt-4">
                            <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                              <label>Show rows:</label>
                              <select
                                value={rowsPerPage}
                                onChange={handleRowsChange}
                                className="form-select w-auto"
                              >
                                <option value={12}>12 items</option>
                                <option value={15}>15 items</option>
                                <option value={20}>20 items</option>
                                <option value={25}>25 items</option>
                              </select>
                            </div>

                            <nav>
                              <ul className="pagination pagination-sm mb-0">
                                {/* Previous */}
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                  <button
                                    className="page-link"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                  >
                                    &lt;
                                  </button>
                                </li>

                                {/* First */}
                                <li className={`page-item ${currentPage === 1 ? "active" : ""}`}>
                                  <button className="page-link" onClick={() => handlePageChange(1)}>
                                    1
                                  </button>
                                </li>

                                {/* Left Dots */}
                                {currentPage > 3 && totalPages > 5 && (
                                  <li className="page-item disabled">
                                    <span className="page-link">...</span>
                                  </li>
                                )}

                                {/* Middle Pages */}
                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                  .filter((page) => {
                                    return (
                                      page !== 1 &&
                                      page !== totalPages &&
                                      Math.abs(currentPage - page) <= 1
                                    );
                                  })
                                  .map((page) => (
                                    <li
                                      key={page}
                                      className={`page-item ${currentPage === page ? "active" : ""}`}
                                    >
                                      <button className="page-link" onClick={() => handlePageChange(page)}>
                                        {page}
                                      </button>
                                    </li>
                                  ))}

                                {/* Right Dots */}
                                {currentPage < totalPages - 2 && totalPages > 5 && (
                                  <li className="page-item disabled">
                                    <span className="page-link">...</span>
                                  </li>
                                )}

                                {/* Last */}
                                {totalPages > 1 && (
                                  <li
                                    className={`page-item ${currentPage === totalPages ? "active" : ""}`}
                                  >
                                    <button className="page-link" onClick={() => handlePageChange(totalPages)}>
                                      {totalPages}
                                    </button>
                                  </li>
                                )}

                                {/* Next */}
                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                  <button
                                    className="page-link"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                  >
                                    &gt;
                                  </button>
                                </li>
                              </ul>
                            </nav>
                          </div>
                        </>
                      )}
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Adminstrator;